import styles from './ProfileUserInfoValue.module.css';

type ProfileUserInfoValueProps = {
  text: string;
  problem: boolean;
};

/** Highlights missing or placeholder user info (not the form control). */
export function ProfileUserInfoValue({ text, problem }: ProfileUserInfoValueProps) {
  if (!problem) {
    return <>{text}</>;
  }
  return <span className={styles.problem}>{text}</span>;
}
